import {Trans} from '@lingui/macro';
import React, {FC, PropsWithChildren, ReactNode} from 'react';

import {KeyboardActionsEnum} from '../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonGroupSpacer} from '../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroupSpacer';
import {SameWidthButton} from '../../../../libs/shared/ui/src/components/buttons/sameWidthButton';
import {KeyboardEventHandlers} from '../../../../libs/shared/ui/src/components/keyboard/keyboardContext';
import {KeyboardShortcuts} from '../../../../libs/shared/ui/src/components/keyboard/keyboardShortcuts';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {Dialog} from './dialog';
import {DialogButtonGroup} from './dialogButtonGroup';
import {DialogContent} from './dialogContent';
import {DialogHeader} from './dialogHeader';

/*
 * Props.
 */

interface AlertDialogProps {
  title: ReactNode;
  onRequestClose: Handler;
  okTitle?: ReactNode;
  onOkClick?: Handler;
}

/*
 * Component.
 */

export const AlertDialog: FC<PropsWithChildren<AlertDialogProps>> = (props) => {
  const {title, children, okTitle, onRequestClose} = props;
  const okButtonText = okTitle || <Trans id="dialogalert-ok-title">Ok</Trans>;
  const keyHandlers: KeyboardEventHandlers = {[KeyboardActionsEnum.CONFIRM]: onRequestClose};
  const onOkClick = props.onOkClick || onRequestClose;

  return (
    <Dialog onRequestClose={onRequestClose}>
      <KeyboardShortcuts handlers={keyHandlers}>
        <DialogHeader title={title} onRequestClose={onRequestClose} />
        <DialogContent>{children}</DialogContent>
        <DialogButtonGroup>
          <ButtonGroupSpacer />
          <SameWidthButton
            variant={ButtonVariantsEnum.PRIMARY}
            size={VisualSizesEnum.MEDIUM}
            onClick={onOkClick}
          >
            {okButtonText}
          </SameWidthButton>
        </DialogButtonGroup>
      </KeyboardShortcuts>
    </Dialog>
  );
};
